"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecializationsCreateDto = void 0;
const specialization_1 = require("../specialization");
const misc_1 = require("../../../misc");
class SpecializationsCreateDto extends (0, misc_1.generateCreateDto)(specialization_1.Specialization, ['name', 'parentSpecIds']) {
}
exports.SpecializationsCreateDto = SpecializationsCreateDto;
